import { CheckSquare, Medal, Swords, Trophy, Users } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { cn } from '@/lib/utils'

const tabs = [
  { path: '/', label: 'タスク', Icon: CheckSquare, end: true },
  { path: '/achievements', label: '実績', Icon: Medal, end: false },
  { path: '/trophies', label: 'トロフィー', Icon: Trophy, end: false },
  { path: '/status', label: 'ステータス', Icon: Swords, end: false },
  { path: '/friends', label: 'フレンド', Icon: Users, end: false },
]

export default function BottomNav() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-[60] flex h-[var(--bottom-nav-h)] bg-background border-t">
      {tabs.map(({ path, label, Icon, end }) => (
        <NavLink
          key={path}
          to={path}
          end={end}
          className={({ isActive }) =>
            cn(
              'flex flex-1 flex-col items-center justify-center gap-0.5 min-h-[44px] py-2 text-xs transition-colors',
              isActive ? 'text-primary' : 'text-muted-foreground',
            )
          }
        >
          <Icon size={20} />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  )
}
